import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getUserDetail } from "redux/actions/Master";
import { AppState } from "redux/store";
import UserUpdate from "./userUpdate";
import UserUpdateHeader from "./userUpdateHeader";

const UserUpdateIndex: React.FC = () => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id?: string }>() || {};
  const userId = id ? Number(id) : undefined;
  const { currentUser } = useSelector<AppState, AppState["master"]>(
    ({ master }) => master
  );

  useEffect(() => {
    dispatch({ type: "RESET_USER" });

    if (userId !== undefined) {
      setTimeout(() => {
        dispatch(getUserDetail(userId));
      }, 1);
    }
  }, [dispatch, userId]);

  return (
    <>
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <AppCard>
          {currentUser ? ( 
            <>
              <UserUpdateHeader user={currentUser} />
              <AppGridContainer>
                <UserUpdate user={currentUser} />
              </AppGridContainer>
            </>
          ) : (
            <p>Loading...</p> 
          )}
        </AppCard>
      </AppAnimate>
      <AppInfoView />
    </>
  );
};

export default UserUpdateIndex;
